module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7JkqqM/tc-custom/9781452170466.jpg?1705766049207",
      "alt": "This image is the cover for the book Cocktails with a Twist"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cocktails with a Twist\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("More than 100 variations on twenty-one classic cocktail recipes: Martini, Bloody Mary, Gimlet, Manhattan, Margarita, Moscow Mule, Sangria, and other iconic drinks.")]), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("A Top Ten Nominee for the 2020 Spirited Awards")]), _c('br'), _c('b', [_vm._v("Finalist for the 2020 IACP Award for Best Cookbook, Wine, Beer or Spirits")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" For anyone looking to expand their palate and discover a new favorite go-to drink, this inventive cocktail book is just the thing. Each chapter is based on a classic (like the Manhattan), but inside readers will discover numerous riffs (like swapping Irish whiskey for rye to make a Blackthorn, or substituting amaro for vermouth to make a Black Manhattan). More than 100 variations on twenty-one modern classic cocktail recipes are accompanied by helpful tips on keeping a well-stocked bar, garnishing drinks, and throwing a party. With bold coloring and classic recipes and intriguing variants, "), _c('i', [_vm._v("Cocktails with a Twist")]), _vm._v(" is a cocktail book unlike any other. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kara Newman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0